import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ThemeToggle from "@/components/shared/ThemeToggle";
import MonogramIcon from "@/components/shared/MonogramIcon";

const Header = () => {
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 w-full bg-background border-b border-border/50 px-6 md:px-10">
      <nav className="flex items-center justify-between py-4 md:py-5">
        {/* Brand - Logo */}
        <a href="/" className="block" aria-label="Site Elevation homepage">
          <MonogramIcon className="h-[72px] w-auto text-foreground" aria-hidden="true" />
        </a>

        {/* CTA + Theme Toggle */}
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Button variant="navCta" onClick={() => navigate("/website-review")} className="text-sm md:text-base px-3 md:px-4">
            <span className="hidden md:inline">Request a Website Review</span>
            <span className="md:hidden">Free Review</span>
          </Button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
